/***********************
 * INDEX TAB3 CONTENT
 * (CALLS)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Locale
import { withTranslation } from "react-i18next"

// Importing components
import CallsTable from "./CallsTable"
import CallsChart from "./CallsChart"
import CardTableBtn from "../CardTableBtn"
// import CallsChartLinear from "./components/CallsChartLinear"

const CallsTabReporting = props => {
  const [callsData, setCallsData] = useState([])
  // Passing customers data to cards/stats
  const [customers, setCustomers] = useState()
  // Filter view related states
  const [widgetVisible, setWidgetVisible] = useState(true)
  const [tableVisible, setTableVisible] = useState(false)
  const [hideShortCalls, setHideShortCalls] = useState(false)

  useEffect(() => {
    if (hideShortCalls) {
      HideShortCalls()
    } else {
      setCallsData(props.data)
    }
    setCustomers(props.customers)
  }, [props.data, hideShortCalls])

  const HideShortCalls = () => {
    if (Array.isArray(props.data?.list)) {
      const filteredList = props.data.list.filter(call => call.duration >= 60)

      const stats = {
        total: filteredList.length,
        caller_relative: 0,
        duration_average: 0,
        duration_median: 0,
        group: 0,
        video: 0,
        tracker: 0,
        carephone: 0,
        phone: 0,
      }

      let durationSum = 0
      for (const call of filteredList) {
        durationSum += call.duration
        if (call.caller_role === "relative") stats.caller_relative++
        if (call.type === "group") stats.group++
        if (call.type === "video") stats.video++
        if (call.type === "tracker") stats.tracker++
        if (call.type === "carephone") stats.carephone++
        if (call.type === "phone") stats.phone++
      }
      if (filteredList.length) {
        stats.duration_average = Math.floor(durationSum / filteredList.length)
        const durations = filteredList
          .map(call => call.duration)
          .sort((a, b) => a - b)
        const mid = Math.floor(durations.length / 2)
        stats.duration_median = Math.floor(
          durations.length % 2 === 0
            ? (durations[mid - 1] + durations[mid]) / 2
            : durations[mid]
        )
      }

      setCallsData({
        ...props.data,
        list: filteredList,
        stats: { ...props.data.stats, ...stats },
      })
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <CardTableBtn
            hideSwitch={true}
            widgetVisible={widgetVisible}
            tableVisible={tableVisible}
            setWidgetVisible={setWidgetVisible}
            setTableVisible={setTableVisible}
            hideShortCalls={hideShortCalls}
            setHideShortCalls={setHideShortCalls}
          ></CardTableBtn>
          <div className="mt-2 mb-1">
            {widgetVisible && (
              <>
                <CallsChart
                  selectedType={props.selectedType}
                  customers={customers}
                  data={callsData}
                  start={props.start}
                  end={props.end}
                  quickGuide={props.quickGuide}
                />
                {/* <CallsChartLinear data={callsData} /> */}
              </>
            )}
            {tableVisible && (
              <CallsTable
                minRows={0}
                selectedType={props.selectedType}
                data={callsData}
              />
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

CallsTabReporting.propTypes = {
  data: PropTypes.any,
  customers: PropTypes.any,
  selectedType: PropTypes.any,
  start: PropTypes.any,
  end: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(CallsTabReporting)
